export const tableData = [
  // {
  //   date: '10.2025',
  //   name: 'Mt. Yake (八重山)',
  //   location: 'Kamikōchi, Japan',
  //   altitude: '2455',
  //   distance: '12.7',
  //   elevation: '400',
  //   rating: '5',
  //   photo_url: '',
  //   notes: '',
  // },
  // {
  //   date: '11.2025',
  //   name: 'Mt. Bukkasan (仏ヶ岳)',
  //   location: 'Nagano, Japan',
  //   altitude: '2057',
  //   distance: '10.2',
  //   elevation: '487',
  //   rating: '5',
  //   photo_url: '',
  //   notes:
  //     'https://www.alltrails.com/sv-se/led/japan/kanagawa/mount-bukkasan-rich-land-campsite-loop',
  // },
  {
    date: '01.2026',
    name: 'Mt. Otake (御岳山)',
    location: 'Tokyo, Japan',
    altitude: '646',
    distance: '11.28',
    elevation: '1266',
    rating: '4',
    photo_url: 'fidacura_japan_otake',
    notes:
      'https://www.alltrails.com/trail/japan/tokyo/okutama-station-mount-odake-mount-mitake',
  },
  {
    date: '12.2025',
    name: 'Naoshima (直島)',
    location: 'Kagawa, Japan',
    altitude: '123',
    distance: '14',
    elevation: '112',
    rating: '5',
    photo_url: 'fidacura_japan_naoshima',
    notes: 'https://www.alltrails.com/trail/japan/kagawa/naoshima-island-run',
  },
  {
    date: '12.2025',
    name: 'Teshima (豊島)',
    location: 'Kagawa, Japan',
    altitude: '310',
    distance: '23',
    elevation: '278',
    rating: '5',
    photo_url: 'fidacura_japan_teshima',
    notes: '',
  },
  {
    date: '11.2025',
    name: 'Mt. Daibosatsu (大菩薩嶺)',
    location: 'Yamanashi, Japan',
    altitude: '2057',
    distance: '9.39',
    elevation: '487',
    rating: '4',
    photo_url: 'fidacura_japan_daibosatsu',
    notes:
      'https://www.alltrails.com/trail/japan/yamanashi/mount-daibosatsu-loop',
  },
  {
    date: '11.2025',
    name: 'Mt. Tsubakuro (椿黒山)',
    location: 'Kamikōchi, Japan',
    altitude: '2763',
    distance: '23.50',
    elevation: '641',
    rating: '5',
    photo_url: 'japan-tsubakuro',
    notes: 'https://www.alltrails.com/trail/japan/nagano/mount-tsubakuro',
  },
  {
    date: '11.2025',
    name: 'Mt. Hikarujo (日暮里山)',
    location: 'Matsumoto, Japan',
    altitude: '912',
    distance: '8.3',
    elevation: '312',
    rating: '4',
    photo_url: 'fidacura_japan_hikarujo',
    notes: 'https://visitazumino.com/en/hiking',
  },
  {
    date: '10.2025',
    name: 'Mt. Mizugaki (瑞牆山)',
    location: 'Yamanashi, Japan',
    altitude: '2230',
    distance: '5.5',
    elevation: '900',
    rating: '5',
    photo_url: 'japan_mizugaki',
    notes:
      'https://www.alltrails.com/trail/japan/yamanashi/mizugakiyama-natural-park-mount-mizugaki-loop',
  },
  {
    date: '10.2025',
    name: 'Nishizawa Gorge (西沢渓谷)',
    location: 'Yamanashi, Japan',
    altitude: '1400',
    distance: '13.63',
    elevation: '593',
    rating: '5',
    photo_url: 'japan-nishizawa-gorge',
    notes:
      'https://www.alltrails.com/trail/japan/yamanashi/nishizawa-gorge-loop',
  },
  {
    date: '05.2025',
    name: 'Chisapani (चिसापानी)',
    location: 'Kathmandu, Nepal',
    altitude: '2174',
    distance: '9.8',
    elevation: '1202',
    rating: '4',
    photo_url: 'nepal-chisapani',
    notes: '',
  },
  {
    date: '05.2025',
    name: 'Sarangkot (साराङ्कोट)',
    location: 'Pokhara, Nepal',
    altitude: '1600',
    distance: '7.2',
    elevation: '400',
    rating: '4',
    photo_url: 'nepal-sarangkot',
    notes: '',
  },
  {
    date: '04.2025',
    name: 'Khopra Danda (खोप्रा डाँडा)',
    location: 'Annapurna, Nepal',
    altitude: '4600',
    distance: '58',
    elevation: '2350',
    rating: '5',
    photo_url: 'nepal-khopra-danda',
    notes: '',
  },

  {
    date: '02.2025',
    name: 'Doi Pui (ดอยปุย)',
    location: 'Thailand',
    altitude: '1500',
    distance: '12.5',
    elevation: '400',
    rating: '4',
    photo_url: 'thailand-tham-Sakoen',
    notes: '',
  },

  {
    date: '01.2025',
    name: 'Mường Hoa Valley',
    location: 'Vietnam',
    altitude: '1600',
    distance: '13.4',
    elevation: '657',
    rating: '5',
    photo_url: 'vietnam-sa-pa',
    notes: '',
  },
  {
    date: '12.2024',
    name: 'Mt Sanpobun (三方分山)',
    location: 'Fujikawaguchiko, Yamanashi, Japan',
    altitude: 1422,
    distance: 10.5,
    elevation: 721,
    rating: 5,
    photo_url: 'fidacura_hikes_sanpobun',
    notes:
      'https://www.alltrails.com/trail/japan/yamanashi/panoramadai-mount-sanpobun-lake-shoji-loop',
  },
  {
    date: '12.2024',
    name: 'Aokigahara Forest (青木ヶ原)',
    location: 'Fujikawaguchiko, Yamanashi, Japan',
    altitude: 1100,
    distance: 12.8,
    elevation: 202,
    rating: 5,
    photo_url: 'fidacura_hikes_aokigahara',
    notes:
      'https://www.alltrails.com/trail/japan/yamanashi/aokigahara-jukai-forest-trekking-loop',
  },
  {
    date: '11.2024',
    name: 'Mt Ishiwari (石割山)',
    location: 'Shishidome, Yamanashi, Japan',
    altitude: 1413,
    distance: 14.8,
    elevation: 475,
    rating: 5,
    photo_url: 'fidacura_hikes_ishiwari',
    notes: '',
  },
  {
    date: '11.2024',
    name: 'Namsan Loop (남산둘레길)',
    location: 'Seoul, South Korea',
    altitude: 1000,
    distance: 8.4,
    elevation: 300,
    rating: 4,
    photo_url: 'fidacura-hikes-namsan',
    notes: 'https://www.alltrails.com/trail/south-korea/seoul/namsan-loop',
  },
  {
    date: '01.2024',
    name: 'Parque das Serras do Porto',
    location: 'Valongo, Portugal',
    altitude: 364,
    distance: 6.8,
    elevation: 275,
    rating: 3,
    photo_url: 'portugal-serras',
    notes:
      'https://www.alltrails.com/trail/portugal/porto--2/senhora-do-salto-castelo-de-aguiar-de-sousa',
  },
  {
    date: '03.2023',
    name: 'Kuang Si Waterfall (ນ້ຳຕົກຕາດ ກວາງຊີ)',
    location: 'Luang Prabang, Laos',
    altitude: 0,
    distance: 8.9,
    elevation: 180,
    rating: 4,
    photo_url: 'laos-kuang-si',
    notes:
      'https://www.alltrails.com/trail/laos/luang-prabang/kuangsi-waterfall-trek',
  },
  {
    date: '03.2023',
    name: 'Pha Daeng (อุทยานแห่งชาติผาแดง)',
    location: 'Luang Prabang, Laos',
    altitude: 1794,
    distance: 3.5,
    elevation: 460,
    rating: 4,
    photo_url: '',
    notes: 'https://www.alltrails.com/trail/laos/louangphrabang/pha-daeng-peak',
  },
  {
    date: '02.2023',
    name: 'Doi Luang (ดอยเชียงดาว)',
    location: 'Chiang Dao, Thailand',
    altitude: 2175,
    distance: 16,
    elevation: 936,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/thailand/chiang-mai/doi-luang-chiang-dao',
  },
  {
    date: '02.2023',
    name: 'Ban Na Lao Mai (บ้านนาเลาใหม่)',
    location: 'Chiang Dao, Thailand',
    altitude: 1065,
    distance: 7.4,
    elevation: 0,
    rating: 4,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/thailand/chiang-mai/ban-na-lao-mai-fa-suai-buddhist-monastery',
  },
  {
    date: '02.2023',
    name: 'Bua Tong Waterfalls (น้ําตกบัวตอง)',
    location: 'Chiang Mai, Thailand',
    altitude: 900,
    distance: 4.5,
    elevation: 148,
    rating: 4,
    photo_url: 'thailand-bua-tong',
    notes:
      'https://www.alltrails.com/trail/thailand/chiang-mai/sticky-falls-medium-loop',
  },
  {
    date: '01.2023',
    name: 'Doi Suthep (วัดพระธาตุดอยสุเทพ)',
    location: 'Chiang Mai, Thailand',
    altitude: 1676,
    distance: 7.2,
    elevation: 696,
    rating: 5,
    photo_url: 'thailand-doi-suthep',
    notes:
      'https://www.alltrails.com/trail/thailand/chiang-mai/doi-suthep-monk-trail',
  },
  {
    date: '12.2022',
    name: 'Ta Prohm Temple (ប្រាសាទតាព្រហ្)',
    location: 'Siem Reap, Cambodia',
    altitude: 0,
    distance: 4,
    elevation: 93,
    rating: 5,
    photo_url: 'cambodia-ta-prohm',
    notes: 'https://www.alltrails.com/trail/cambodia/siem-reap/ta-prohm-temple',
  },
  {
    date: '12.2022',
    name: 'Phnom Kulen (ភ្នំគូលែន)',
    location: 'Phnom Kulen National Park, Cambodia',
    altitude: 0,
    distance: 7.5,
    elevation: 39,
    rating: 5,
    photo_url: 'cambodia-phnom-kulen',
    notes: 'https://www.alltrails.com/trail/cambodia/siem-reap/mount-kulen',
  },
  {
    date: '12.2022',
    name: 'Bayon Temple (ព្រះបាទជ័យវរ្ម័នទី ៧)',
    location: 'Siem Reap, Cambodia',
    altitude: 0,
    distance: 3,
    elevation: 93,
    rating: 5,
    photo_url: 'cambodia-bayon',
    notes: 'https://www.alltrails.com/trail/cambodia/siem-reap/bayon-temple',
  },
  {
    date: '12.2022',
    name: 'Angkor Wat (អង្គរវត្ត)',
    location: 'Siem Reap, Cambodia',
    altitude: 0,
    distance: 4,
    elevation: 0,
    rating: 5,
    photo_url: 'cambodia-angkor-wat',
    notes: 'https://www.alltrails.com/trail/cambodia/siem-reap/angkor-wat',
  },
  {
    date: '12.2022',
    name: 'Keelung Mountain (基隆山)',
    location: 'Ruifang, New Taipei City, Taiwan',
    altitude: 588,
    distance: 2,
    elevation: 78,
    rating: 5,
    photo_url: 'taiwan-keelung',
    notes:
      'https://www.alltrails.com/trail/taiwan/new-taipei-city/mt-keelung-trail',
  },
  {
    date: '12.2022',
    name: 'Nangang Mountain Main Ridge (南港山)',
    location: 'Xinyl, Taipei City, Taiwan',
    altitude: 382,
    distance: 4,
    elevation: 297,
    rating: 5,
    photo_url: 'taiwan-nangang',
    notes:
      'https://www.alltrails.com/trail/taiwan/taipei-city/nangang-mountain-main-ridge-trail',
  },
  {
    date: '12.2022',
    name: 'Elephant Mountain (象山)',
    location: 'Xinyl, Taipei City, Taiwan',
    altitude: 183,
    distance: 1.5,
    elevation: 144,
    rating: 5,
    photo_url: 'taiwan-xiangshan',
    notes:
      'https://www.alltrails.com/trail/taiwan/taipei-city/elephant-mountain-trail--2',
  },
  {
    date: '03.2022',
    name: 'Caldera Blanca',
    location: 'Lanzarote, Las Palmas, Spain',
    altitude: 0,
    distance: 9.3,
    elevation: 406,
    rating: 5,
    photo_url: 'spain-lanzarote-caldera-blance',
    notes:
      'https://www.alltrails.com/trail/spain/lanzarote/gg-2-mancha-blanca-caldera-blanca',
  },
  {
    date: '03.2022',
    name: 'Monte Corona',
    location: 'Lanzarote, Las Palmas, Spain',
    altitude: 458,
    distance: 3.4,
    elevation: 142,
    rating: 5,
    photo_url: 'spain-lanzarote-monte-corona',
    notes: 'https://www.alltrails.com/trail/spain/lanzarote/monte-corona',
  },
  {
    date: '03.2022',
    name: 'Caldera de los Cuervos',
    location: 'Lanzarote, Las Palmas, Spain',
    altitude: 345,
    distance: 4.5,
    elevation: 90,
    rating: 5,
    photo_url: 'spain-lanzarote-caldera-de-los-cuervos',
    notes:
      'https://www.alltrails.com/es/ruta/spain/lanzarote/caldera-de-los-cuervos',
  },
  {
    date: '03.2022',
    name: 'Volcán Montaña Colorada',
    location: 'Lanzarote, Las Palmas, Spain',
    altitude: 240,
    distance: 3.5,
    elevation: 58,
    rating: 4,
    photo_url: 'spain-lanzarote-montana-colorada',
    notes: '/',
  },
  {
    date: '03.2022',
    name: 'Montaña de Tinaguache',
    location: 'Lanzarote, Las Palmas, Spain',
    altitude: 235,
    distance: 5.5,
    elevation: 230,
    rating: 5,
    photo_url: 'spain-lanzarote-montana-tinaguache',
    notes:
      'https://www.alltrails.com/es/ruta/spain/lanzarote/volcan-montana-colorada',
  },
  {
    date: '12.2021',
    name: 'Lagos de Covadonga',
    location: 'Cangas de Onís, Asturias, Spain',
    altitude: 1134,
    distance: 6.5,
    elevation: 230,
    rating: 4,
    photo_url: 'spain-covadonga',
    notes: '/',
  },
  {
    date: '03.2021',
    name: 'Percurso das Tapadas',
    location: 'Ponte de Lima, Portugal',
    altitude: 426,
    distance: 3.7,
    elevation: 46,
    rating: 4,
    photo_url: 'portugal-tapadas',
    notes:
      'https://www.alltrails.com/trail/spain/asturias/lagos-de-covadonga-pico-la-muda-cabeza-del-burro',
  },
  {
    date: '03.2020',
    name: 'Alto da Fóia',
    location: 'Monchique, Portugal',
    altitude: 902,
    distance: 7.6,
    elevation: 900,
    rating: 4,
    photo_url: 'portugal-monchique',
    notes:
      'https://www.alltrails.com/sv-se/led/portugal/faro/circuito-do-alto-da-foia',
  },
  {
    date: '11.2019',
    name: 'Darabad (دروار)',
    location: 'Tehran, Iran',
    altitude: 3202,
    distance: 9.5,
    elevation: 0,
    rating: 5,
    photo_url: 'iran-darabad',
    notes: 'https://www.alltrails.com/trail/iran/tehran/darabad',
  },
  {
    date: '11.2019',
    name: 'Marīvān (مريوان;)',
    location: 'Kordestān, Iran',
    altitude: 1310,
    distance: 10,
    elevation: 0,
    rating: 5,
    photo_url: 'iran-marivan',
    notes: '',
  },
  {
    date: '11.2019',
    name: 'Bolbar (بُلبَر, بلبر)',
    location: 'Kordestān, Iran',
    altitude: 954,
    distance: 12.5,
    elevation: 0,
    rating: 5,
    photo_url: 'iran-bolbar',
    notes: '',
  },
  {
    date: '11.2019',
    name: 'Galin (گلين)',
    location: 'Kordestān, Iran',
    altitude: 2044,
    distance: 12,
    elevation: 0,
    rating: 5,
    photo_url: 'iran-galin',
    notes:
      'https://www.wikiloc.com/car-trails/the-hidden-paradise-galin-35998309',
  },
  {
    date: '11.2019',
    name: 'Coastline (جزیره هرمز)',
    location: 'Ormuz, Iran',
    altitude: 186,
    distance: 12,
    elevation: 0,
    rating: 4,
    photo_url: 'iran-ormuz',
    notes: '',
  },
  {
    date: '11.2019',
    name: 'Chak Chakū (چک‌چک)',
    location: 'Yazd, Iran',
    altitude: 1229,
    distance: 8,
    elevation: 0,
    rating: 4,
    photo_url: 'iran-yazd',
    notes: '',
  },
  {
    date: '06.2019',
    name: 'Panneland Blue Trail',
    location: 'North Holland, Netherlands',
    altitude: 0,
    distance: 8,
    elevation: 86,
    rating: 3,
    photo_url: 'netherlands-blue',
    notes:
      'https://www.alltrails.com/trail/netherlands/north-holland/panneland-blauwe-wandelroute',
  },
  {
    date: '05.2019',
    name: 'Tamsin Trail',
    location: 'London, UK',
    altitude: 0,
    distance: 11.7,
    elevation: 232,
    rating: 3,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/england/london/richmond-park-and-east-sheen-common-circular',
  },
  {
    date: '08.2019',
    name: 'Parkland Walk',
    location: 'London, UK',
    altitude: 0,
    distance: 6.4,
    elevation: 159,
    rating: 3,
    photo_url: 'london-parkland-walk',
    notes: 'https://www.alltrails.com/trail/england/london/parkland-walk',
  },
  {
    date: '06.2019',
    name: 'Lac de Monteynard',
    location: 'Treffort, Isère, France',
    altitude: 500,
    distance: 11.9,
    elevation: 467,
    rating: 5,
    photo_url: 'france-monteynard',
    notes:
      'https://www.alltrails.com/trail/france/isere/passerelles-himalayennes-du-lac-de-monteynard-avignonet',
  },
  {
    date: '06.2019',
    name: 'Rocher des Deux Trous',
    location: 'Provence, France',
    altitude: 0,
    distance: 8.7,
    elevation: 261,
    rating: 4,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/france/bouches-du-rhone/rocher-des-deux-trous-depuis-saint-remy-de-provence',
  },
  {
    date: '03.2019',
    name: 'Yr Wyddfa (Snowden)',
    location: 'Caernarfon, Wales, UK',
    altitude: 1085,
    distance: 12,
    elevation: 752,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/wales/gwynedd/yr-wyddfa-snowdon-via-miner-s-track',
  },
  {
    date: '03.2019',
    name: 'Yr Wyddfa (Snowden)',
    location: 'Caernarfon, Wales, UK',
    altitude: 1085,
    distance: 8,
    elevation: 0,
    rating: 5,
    photo_url: 'wales-snowden-1',
    notes: '',
  },
  {
    date: '03.2019',
    name: 'Prince of Wales Quarry',
    location: 'Betws Garmon, Wales, UK',
    altitude: 368,
    distance: 11.5,
    elevation: 0,
    rating: 5,
    photo_url: 'wales-quarry',
    notes:
      'https://www.wikiloc.com/hiking-trails/prince-of-wales-quarry-near-beddgelert-2350669',
  },
  {
    date: '03.2019',
    name: 'Hampstead Heath Circular',
    location: 'London, UK',
    altitude: 0,
    distance: 7.4,
    elevation: 201,
    rating: 4,
    photo_url: 'uk-hampstead',
    notes:
      'https://www.alltrails.com/trail/england/london/hampstead-heath-circular-walk',
  },
  {
    date: '01.2018',
    name: 'Lang Biang',
    location: 'Dalat, Vietnam',
    altitude: 2167,
    distance: 7.2,
    elevation: 212,
    rating: 3,
    photo_url: 'vietnam-dalat',
    notes:
      'https://www.alltrails.com/trail/vietnam/lam-d-ng/lang-biang-mountain',
  },
  {
    date: '12.2018',
    name: 'Cuc Phuong National Park',
    location: 'Ninh Bình, Vietnam',
    altitude: 648,
    distance: 10,
    elevation: 266,
    rating: 4,
    photo_url: 'vietnam-cuc-phuong',
    notes:
      'https://www.alltrails.com/parks/vietnam/ninh-binh/cuc-phuong-national-park',
  },
  {
    date: '12.2018',
    name: 'Dinh Ngu Lam',
    location: 'Cat Ba. Vietnam',
    altitude: 225,
    distance: 2.9,
    elevation: 168,
    rating: 4,
    photo_url: 'vietnam-catba',
    notes: 'https://www.alltrails.com/trail/vietnam/haiphong/dinh-ngu-lam',
  },
  {
    date: '06.2018',
    name: 'Epping Forest',
    location: 'London, UK',
    altitude: 0,
    distance: 8.9,
    elevation: 395,
    rating: 4,
    photo_url: 'london-epping-forest',
    notes:
      'https://www.alltrails.com/trail/england/london/epping-forest-circular',
  },

  {
    date: '08.2017',
    name: 'Trilho do Lobo',
    location: 'Fafião, Portugal',
    altitude: 579,
    distance: 4.5,
    elevation: 0,
    rating: 3,
    photo_url: 'geres-trilho-do-lobo',
    notes:
      'https://pt.wikiloc.com/trilhas-trekking/trilho-do-lobo-fafiao-38145588',
  },
  {
    date: '07.2016',
    name: 'Auronzo Refuge',
    location: 'Veneto, Italy',
    altitude: 2320,
    distance: 6.9,
    elevation: 318,
    rating: 5,
    photo_url: 'italia-rifugio',
    notes:
      'https://www.alltrails.com/trail/italy/south-tyrol/rifugio-auronzo-tre-cime-di-lavaredo',
  },
  {
    date: '07.2016',
    name: 'Cinque Torri',
    location: 'Veneto, Italy',
    altitude: 2361,
    distance: 4.3,
    elevation: 258,
    rating: 5,
    photo_url: 'italia-cinque-torri',
    notes:
      'https://www.alltrails.com/trail/italy/veneto/baita-bai-de-dones-cinque-torri',
  },
  {
    date: '06.2015',
    name: 'Trilho da Calcedónia',
    location: 'Covide, Portugal',
    altitude: 840,
    distance: 10,
    elevation: 429,
    rating: 4,
    photo_url: 'geres-calcedonia',
    notes:
      'https://www.alltrails.com/pt-pt/trilho/portugal/braga/pr1-trilho-da-cidada-da-calcedonia',
  },
  {
    date: '06.2014',
    name: 'Turio',
    location: 'Vieira do Minho, Portugal',
    altitude: 1262,
    distance: 10,
    elevation: 0,
    rating: 4,
    photo_url: 'portugal-geres-turio',
    notes:
      'https://www.alltrails.com/trail/portugal/braga/pr4-vrm-percurso-do-turio',
  },
  {
    date: '05.2014',
    name: 'Trilho dos Canos de Água',
    location: 'Viana do Castelo, Portugal',
    altitude: 225,
    distance: 10.5,
    elevation: 368,
    rating: 3,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/portugal/viana-do-castelo/pr9-vct-monte-de-santa-luzia-sao-mamede-e-trilho-dos-canos-de-agua',
  },
  {
    date: '10.2013',
    name: 'Ansiães',
    location: 'Serra do Marão, Portugal',
    altitude: 1418,
    distance: 13.4,
    elevation: 188,
    rating: 5,
    photo_url: 'portugal-ansiaes',
    notes:
      'https://www.alltrails.com/trail/portugal/porto--2/rota-circular-de-ansiaes',
  },
  {
    date: '05.2013',
    name: 'Briksdalsbreen',
    location: 'Briksdalsbre, Norway',
    altitude: 1910,
    distance: 5.3,
    elevation: 1063,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/sv-se/led/norway/sogn-og-fjordane/briksdalsbreen',
  },
  {
    date: '04.2013',
    name: 'Ulriken',
    location: 'Bergen, Norway',
    altitude: 643,
    distance: 8,
    elevation: 866,
    rating: 5,
    photo_url: '',
    notes: '/',
  },
  {
    date: '03.2013',
    name: 'Blåmanen Loop',
    location: 'Bergen, Norway',
    altitude: 494,
    distance: 6.9,
    elevation: 384,
    rating: 5,
    photo_url: '',
    notes: 'https://www.alltrails.com/trail/norway/vestland/blamanen-rundtur',
  },
  {
    date: '03.2013',
    name: 'Vidden Hike',
    location: 'Bergen, Norway',
    altitude: 644,
    distance: 13.2,
    elevation: 414,
    rating: 5,
    photo_url: '',
    notes: 'https://www.alltrails.com/trail/norway/vestland/ulriken-rundtur',
  },
  {
    date: '02.2013',
    name: 'Fløyen',
    location: 'Bergen, Norway',
    altitude: 320,
    distance: 7.5,
    elevation: 380,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/norway/hordaland/bergen-og-floyen-rund',
  },
  {
    date: '08.2012',
    name: 'Trilho dos Currais',
    location: 'Gerês, Portugal',
    altitude: 935,
    distance: 10.6,
    elevation: 648,
    rating: 4,
    photo_url: 'portugal-geres-currais',
    notes:
      'https://www.alltrails.com/trail/portugal/braga/pr3-tbr-trilho-dos-currais',
  },
  {
    date: '08.2012',
    name: 'Pedra Bela',
    location: 'Gerês, Portugal',
    altitude: 829,
    distance: 13,
    elevation: 528,
    rating: 4,
    photo_url: '',
    notes: 'https://www.alltrails.com/trail/portugal/braga/trilho-pedra-bela',
  },
  {
    date: '08.2012',
    name: 'Ifni Lake',
    location: 'Atlas, Morocco',
    altitude: 2295,
    distance: 8.5,
    elevation: 388,
    rating: 5,
    photo_url: 'morocco-ifni',
    notes:
      'https://www.alltrails.com/explore/recording/tour-du-toubkal-j4-amsouzart-lac-d-ifni--2?u=m',
  },
  {
    date: '08.2012',
    name: 'Waterfall Trail',
    location: 'Ourika Valley, Morocco',
    altitude: 1500,
    distance: 6.5,
    elevation: 290,
    rating: 4,
    photo_url: 'morocco-ourika',
    notes: '',
  },
  {
    date: '06.2012',
    name: 'Brijuni',
    location: 'Pula, Croatia',
    altitude: 0,
    distance: 10,
    elevation: 164,
    rating: 4,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/croatia/istra/luka-brijuni-safari-park-uvala-verige',
  },
  {
    date: '03.2012',
    name: 'Monte Pozza',
    location: 'Dolomites, Bolzano, Italy',
    altitude: 1615,
    distance: 8,
    elevation: 514,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/italy/south-tyrol/monte-pozza-via-colle',
  },
  {
    date: '07.2012',
    name: 'Geira Romana',
    location: 'Chamoim, Gerês, Portugal',
    altitude: 450,
    distance: 6.5,
    elevation: 238,
    rating: 4,
    photo_url: 'portugal-geres-geira-romana',
    notes:
      'https://www.alltrails.com/trail/portugal/braga/caminhos-da-geira-romana-em-campos-do-geres',
  },
  {
    date: '06.2012',
    name: 'Sete Lagoas',
    location: 'Covelo do Gerês, Portugal',
    altitude: 774,
    distance: 9.7,
    elevation: 292,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/brazil/minas-gerais/sinuosa-parque-da-cascata',
  },
  {
    date: '05.2012',
    name: 'Cascatas do Arado (Waterfalls)',
    location: 'Vilar de Veiga, Gerês, Portugal',
    altitude: 900,
    distance: 10,
    elevation: 195,
    rating: 4,
    photo_url: '',
    notes: '',
  },
  {
    date: '06.2011',
    name: 'Mount Tibidabo',
    location: 'Barcelona, Catalonia, Spain',
    altitude: 512,
    distance: 6.4,
    elevation: 269,
    rating: 4,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/spain/barcelona/montana-del-tibidabo',
  },
  {
    date: '04.2011',
    name: 'Sant Jeroni, Montserrat',
    location: 'Barcelona, Catalonia, Spain',
    altitude: 1236,
    distance: 8.5,
    elevation: 551,
    rating: 4,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/spain/barcelona/circuito-de-la-cumbre-de-sant-jeroni',
  },
  {
    date: '03.2011',
    name: 'Campo do Gerês',
    location: 'Gerês, Portugal',
    altitude: 630,
    distance: 12,
    elevation: 0,
    rating: 4,
    photo_url: '',
    notes: '/',
  },
  {
    date: '03.2011',
    name: 'Poço Azul',
    location: 'Ruivães, Gerês, Portugal',
    altitude: 900,
    distance: 8.4,
    elevation: 305,
    rating: 4,
    photo_url: 'geres-poco-azul',
    notes:
      'https://www.alltrails.com/trail/portugal/braga/trilho-da-cascata-do-arado-e-poco-azul',
  },
  {
    date: '10.2010',
    name: 'Tosh - Mantalai Lake',
    location: 'Parvati Valley, Himachal Pradesh, India',
    altitude: 4100,
    distance: 45.5,
    elevation: 380,
    rating: 5,
    photo_url: '',
    notes: '',
  },
  {
    date: '10.2010',
    name: 'Tosh - Budhaban Trek',
    location: 'Parvati Valley, Himachal Pradesh, India',
    altitude: 2200,
    distance: 6.5,
    elevation: 550,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/india/himachal-pradesh/budhaban-tosh-trail',
  },
  {
    date: '10.2010',
    name: 'Hampta Pass',
    location: 'Manali, Himachal Pradesh, India',
    altitude: 4270,
    distance: 21.7,
    elevation: 1551,
    rating: 5,
    photo_url: '',
    notes: '/',
  },
  {
    date: '08.2010',
    name: 'Dhugan Valley (हिन्दी मे मीनिंग)',
    location: 'Manali, Himachal Pradesh, India',
    altitude: 2050,
    distance: 5.5,
    elevation: 330,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/india/himachal-pradesh/old-manali-dhugan-valley-trek',
  },
  {
    date: '08.2010',
    name: 'Jogini Waterfall (जोगिनी)',
    location: 'Manali, Himachal Pradesh, India',
    altitude: 3700,
    distance: 6.6,
    elevation: 409,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/india/himachal-pradesh/jogini-waterfall',
  },
  {
    date: '08.2010',
    name: 'Wayland Viewpoint',
    location: 'Manali, Himachal Pradesh, India',
    altitude: 3770,
    distance: 5.5,
    elevation: 303,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/india/himachal-pradesh/old-manali-wayland-viewpoint-trail',
  },
  {
    date: '09.2010',
    name: 'Shri Guna Devi Mandir (श्री गुना देवी मंदिर)',
    location: 'Dharamshala, Himachal Pradesh, India',
    altitude: 2310,
    distance: 7.9,
    elevation: 378,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/india/himachal-pradesh/shri-guna-devi-mandir',
  },
  {
    date: '09.2010',
    name: 'Indrahar Pass Trail',
    location: 'Dharamshala, Himachal Pradesh, India',
    altitude: 4342,
    distance: 21.4,
    elevation: 2718,
    rating: 5,
    photo_url: '',
    notes: '',
  },
  {
    date: '09.2010',
    name: 'Karthani - Leta Trail',
    location: 'Dharamshala, Himachal Pradesh, India',
    altitude: 2700,
    distance: 10.3,
    elevation: 1124,
    rating: 5,
    photo_url: '',
    notes: '/',
  },
  {
    date: '09.2010',
    name: 'Bhagsu Nag Trail (बिबरण)',
    location: 'Dharamshala, Himachal Pradesh, India',
    altitude: 2082,
    distance: 3.5,
    elevation: 354,
    rating: 5,
    photo_url: '',
    notes: '',
  },
  {
    date: '09.2010',
    name: 'Dal Lake (डल झील)',
    location: 'Dharamshala, Himachal Pradesh, India',
    altitude: 1583,
    distance: 16,
    elevation: 1409,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/india/himachal-pradesh/dal-lake-dharamkot-loop',
  },
  {
    date: '08.2010',
    name: 'Kunjapuri (कुंजापुरी सिद्धपीठ)',
    location: 'Rishikesh, Uttarakhand, India',
    altitude: 1676,
    distance: 11.5,
    elevation: 1450,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/india/uttarakhand/kunjapuri-temple-trail',
  },
  {
    date: '08.2010',
    name: 'Neelkanth Mahadev Temple',
    location: 'Rishikesh, Uttarakhand, India',
    altitude: 1330,
    distance: 8.7,
    elevation: 981,
    rating: 5,
    photo_url: '',
    notes: '',
  },
  {
    date: '08.2010',
    name: 'Neer Garh Waterfalls',
    location: 'Rishikesh, Uttarakhand, India',
    altitude: 744,
    distance: 3.5,
    elevation: 282,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/india/uttarakhand/neer-garh-waterfalls',
  },
  {
    date: '07.2011',
    name: 'Savitri Mountain (सावित्री माता टेम्पल)',
    location: 'Pushkar, Rajasthan, India',
    altitude: 228,
    distance: 2.5,
    elevation: 0,
    rating: 4,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/india/rajasthan/savitri-mata-temple',
  },
  {
    date: '07.2011',
    name: 'Nahargarh Fort (नाहरगढ़ दुर्ग)',
    location: 'Jaipur, Rajasthan, India',
    altitude: 213,
    distance: 8,
    elevation: 292,
    rating: 4,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/india/rajasthan/nahargarh-fort-trail',
  },
  {
    date: '07.2010',
    name: 'Ghats (वाराणसी में घाट)',
    location: 'Varanasi, Uttar Pradesh, India',
    altitude: 0,
    distance: 13.5,
    elevation: 241,
    rating: 5,
    photo_url: '',
    notes: 'https://www.alltrails.com/trail/india/uttar-pradesh/varanasi-ghats',
  },
  {
    date: '07.2009',
    name: 'Phaeng Noi Waterfall (น้ำตกแพงน้อย)',
    location: 'Surat Thani, Thailand',
    altitude: 0,
    distance: 2.9,
    elevation: 278,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/thailand/surat-thani/phaeng-noi-waterfall-loop',
  },
  {
    date: '07.2009',
    name: 'Khao Ra',
    location: 'Surat Thani, Thailand',
    altitude: 0,
    distance: 5.8,
    elevation: 593,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/thailand/surat-thani/khao-ra-lookout-trail',
  },
  {
    date: '07.2009',
    name: 'Khao Hang Nak (เขาหงอนนาค)',
    location: 'Mu Koh Phi Phi National Park, Thailand',
    altitude: 0,
    distance: 7.2,
    elevation: 554,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/thailand/krabi/khao-hang-nak-hill-nature-trail',
  },
  {
    date: '07.2009',
    name: 'Silver Cliff',
    location: 'Vang Vieng, Laos',
    altitude: 700,
    distance: 3.7,
    elevation: 481,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/laos/vientiane/silver-cliff-upper-and-lower-viewpoint-trail',
  },
  {
    date: '06.2009',
    name: 'Huay Kaew Waterfall (น้ำตกห้วยแก้ว)',
    location: 'Chiang Rai, Thailand',
    altitude: 0,
    distance: 10.9,
    elevation: 467,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/thailand/chiang-rai/huay-kaew-waterfall-extended-loop',
  },
  {
    date: '06.2009',
    name: 'Doi Suthep (วัดพระธาตุดอยสุเทพ)',
    location: 'Chiang Mai, Thailand',
    altitude: 1676,
    distance: 7.2,
    elevation: 696,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/thailand/chiang-mai/doi-suthep-monk-trail',
  },
  {
    date: '06.2009',
    name: 'Mae Yen Waterfall (แม่เย็น)',
    location: 'Pai, Thailand',
    altitude: 0,
    distance: 16,
    elevation: 740,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/thailand/mae-hong-son/mae-yen-waterfall',
  },
  {
    date: '06.2009',
    name: 'Khao Luang (เขาหลวง,)',
    location: 'Sukhothai, Thailand',
    altitude: 0,
    distance: 8.4,
    elevation: 945,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/thailand/nakhon-sawan/khao-luang-nakhon-sawan-trail',
  },
  {
    date: '06.2009',
    name: 'Ayutthaya Island (รอบเกาะอยุธยา)',
    location: 'Ayutthaya, Thailand',
    altitude: 0,
    distance: 11.4,
    elevation: 93,
    rating: 5,
    photo_url: '',
    notes:
      'https://www.alltrails.com/trail/thailand/phranakhon-si-ayutthaya/ayutthaya-island',
  },
];
